#content
<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="position-relative sf-col sf-col-20" v-if="isLoaded">
				<left-buttons
					:scrId="scrId"
					@Refresh="refresh"
					@RefreshReIns="refreshReIns"
					:flgOsGrp="this.flgOsGrp"
					:flgPqyapGrp="this.flgPqyapGrp"
					:flgPqyrvGrp="this.flgPqyrvGrp"
					:flgPqyrgGrp="this.flgPqyrgGrp"
				></left-buttons>
				<right-buttons
					:scrId="scrId"
					@Refresh="refresh"
					:flgOsGrp="this.flgOsGrp"
					:flgPqyapGrp="this.flgPqyapGrp"
					:flgPqyrvGrp="this.flgPqyrvGrp"
					:flgPqyrgGrp="this.flgPqyrgGrp"
				></right-buttons>
				<sf-card class="p-0 border-0 bg-transparent">
					<form-view
						@Refresh="refresh"
						:scrId="scrId"
						class="mb-2"
						:flgOsGrp="this.flgOsGrp"
						:flgPqyapGrp="this.flgPqyapGrp"
						:flgPqyrvGrp="this.flgPqyrvGrp"
						:flgPqyrgGrp="this.flgPqyrgGrp"
					></form-view>
					<form-reject @Refresh="refresh" :scrId="scrId"></form-reject>
				</sf-card>
				<sf-card class="p-0 border-0 bg-transparent m-0">
					<table-view
						ref="tableView"
						@tableMounted="tableMounted"
						@Refresh="refresh"
						:scrId="scrId"
						:flgOsGrp="this.flgOsGrp"
						:flgPqyapGrp="this.flgPqyapGrp"
						:flgPqyrvGrp="this.flgPqyrvGrp"
						:flgPqyrgGrp="this.flgPqyrgGrp"
					></table-view>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';

import SearchView from './Search/Search';
import LeftButtons from './Table/LeftButtons';
import RightButtons from './Table/RightButtons';
import TableView from './Table/Table';
import FormView from './Table/Form';
import FormReject from './Table/FormReject';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false,
			flgOsGrp: false, //시스템관리자
			flgPqyapGrp: false, //관리자(승인)
			flgPqyrvGrp: false, //중간관리자(검토)
			flgPqyrgGrp: false //업무담당자(작성)
		};
	},
	async created() {
		this.$sf_toggleLoading(true); //테이블 렌더링이 오래 걸리기 떄문에 해당 메소드에서 false를 하지 않고, 하단의 tableMounted에서 진행한다.
		this.isLoaded = false;
		await this.getCommCodesOnce_(); //공통코드 한번에 부르기
		await this.getOs(); // 시스템 총괄그룹
		await this.getPqyap(); //승인자그룹
		await this.getPqyrv(); //검토자그룹
		await this.getPqyrg(); //작성자그룹
		this.isLoaded = true;

		// await this.getCommCodes_({ key: 'passDsqfList', codeType: 'INDV_JGMT' }); //합불기준코드;
		// await this.getCommCodes_({ key: 'partClList', codeType: 'PART_CL' }); //유형;
		// await this.getCommCodes_({ key: 'ovrlJgmtList', codeType: 'OVRL_JGMT' }); //종합판정;
		// await this.getCommCodes_({ key: 'ckuScnList', codeType: 'CKU_SCN' }); //검사구분;

		// await this.getCommCodes_({ key: 'ckuPrvsList', codeType: 'CKU_PRVS' }); //대분류(검사항목);
		// await this.getCommCodes_({ key: 'ckuClList', codeType: 'CKU_CL' }); //소분류(검사분류);
		// await this.getCommCodes_({ key: 'ckuWayList', codeType: 'CKU_WAY' }); //검사방법;
		// await this.getCommCodes_({ key: 'jgmtCrtnList', codeType: 'JGMT_CRTN' }); //판정기준;
	},
	components: { SearchView, TableView, FormView, RightButtons, LeftButtons, FormReject },
	computed: {
		...rootComputed,
		...serviceComputed,
		...qmsComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		refresh(params) {
			//console.log(params);
			if (params) {
				this.$refs.searchView.setSearchParam({ key: 'partNo', value: params.partNo });
				if (params.ckuNo != undefined && params.ckuNo !== '') {
					this.$refs.searchView.setSearchParam({ key: 'ckuNo', value: params.ckuNo });
					this.$refs.searchView.setSearchParam({ key: 'partClCd', value: '' });
				}
			}
			this.$refs.searchView.searchList();
		},
		refreshReIns(params) {
			this.$refs.searchView.setSearchParam({ key: 'partNo', value: params.partNo });
			this.$refs.searchView.setSearchParam({ key: 'ckuNo', value: params.ckuNo });
			this.$refs.searchView.searchList();
		},
		tableMounted() {
			//테이블 화면 렌더링이 오래걸리기 때문에 사용감을 위해서 테이블 렌더링이 완료가 되면 emit을 통해 신호를 받고 로딩바를 종료시킨다.
			this.$sf_toggleLoading(false);
		},
		async getOs() {
			this.flgOsGrp = await this.inclUsrGrp_('OS'); //시스템 관리자
			// console.log('Content flgOsGrp >>> ', this.flgOsGrp);
		},
		async getPqyap() {
			this.flgPqyapGrp = await this.inclUsrGrp_('PQYAP'); //생산품질 관리자(승인)
			// console.log('Content getPqyap >>> ', this.flgPqyapGrp);
		},
		async getPqyrv() {
			this.flgPqyrvGrp = await this.inclUsrGrp_('PQYRV'); //생산품질 중간관리자(검토)
			// console.log('Content getPqyrv >>> ', this.flgPqyrvGrp);
		},
		async getPqyrg() {
			this.flgPqyrgGrp = await this.inclUsrGrp_('PQYRG'); //생산품질 일반사용자(작성)
			// console.log('Content getPqyrg >>> ', this.flgPqyrgGrp);
		}
	}
};
</script>

<style></style>
